import styled from 'styled-components';
import { dimensions, colors, typography } from 'modules/common/styles';
import { BoxRoot } from 'modules/common/styles/main';

const rowTitleSize = 230;
const boxSize = 150;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: ${dimensions.coreSpacing}px;
`;

const DataWrapperClass = styled.div`
  section.sc-feJyhm.cHLQhJ {
    background: #fff;
    overflow: hidden;
  }
  .sc-cmTdod.cpKXNr {
    overflow: hidden;
  }
  section.sc-jtRfpW.daxgFZ {
    margin-right: 20px;
  }
  section.sc-iELTvK.dstvIj {
    background: #fff;
    margin-left: 20px;
  }
`;

const MainBox = styled.div`
  bottom: 0;
  width: 25%;
  height: 470px;
  background: #fff;
  position: fixed;
  border-radius: 9px 9px 0px 0px;
  box-shadow: 0 2px 4px rgb(15 34 58 / 12%);
  right: 3%;
  border: none;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 15px;
  background: ${colors.colorWhite};
  border-radius: 9px 9px 0px 0px;

  h6 {
    font-size: 14px;
    margin: 0;
  }

  .iconCircle i {
    color: ${colors.colorCoreGreen};
    font-size: 9px;
    margin-right: 9px;
  }

  .logo {
    margin: 0px;
    width: 100%;
  }
  .close {
    color: #9b9b9d;
  }
`;

const Footer = styled.div`
  background: ${colors.colorWhite};
  padding: 1rem 1rem 1rem 1rem;
  font-size: 18px;
  height: 50px;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 67px;
  margin-top: 5px;
  width: 100%;

  .row {
    height: 100%;
    display: flex;
    align-items: center;
  }
  .col {
    text-align: center;
    padding: 0.25rem;
  }

  .activeIcon {
    background: transparent
      linear-gradient(91deg, #4c83f2 0%, #3263c5 44%, #2c336d 100%);
    border-radius: 50px;
    width: 36px;
    height: 36px;
    color: ${colors.colorWhite};
    margin: auto;
    padding: 3px;
  }
`;

const MainBody = styled.div`
  background: transparent
    linear-gradient(
      90deg,
      ${colors.colorPrimary} 0%,
      ${colors.colorCoreBlue} 100%
    );
  color: ${colors.colorWhite};
  padding: 14px 15px;
  display: flex;
  align-items: center;

  h6 {
    font-size: 15px;
    font-weight: 400;
    margin: 0;
  }

  span {
    font-size: 12px;
    font-weight: 400;
    color: ${colors.colorLightGrey};
  }
`;

const OverflowClass = styled.div`
  overflow-y: auto;
  height: -webkit-fill-available;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: 2px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #c2c2ce;
    border: 1px solid #c2c2ce;
  }
`;

const BodyClass = styled.div`
  background: ${colors.colorWhite};
  margin: 0;
  border-radius: 0px;
  padding: 12px 15px;
  display: block;

  h5 {
    font-size: 15px;
    text-align: center;
    color: ${colors.colorPrimary};
    margin-top: 0.5rem !important;
  }

  .hoverChat {
    padding: 0.2rem 0.5rem;
    &:hover {
      border: 1px solid #dbe5ed;
      background: #f9fafc;
      border-radius: 10px;
    }
  }
`;

const AgentList = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;

  h6 {
    color: #1a1848;
    letter-spacing: 0.3px;
    font-size: 14px;
    font-weight: 400;
    width: 75%;
    margin-left: 1.5rem;
    margin-bottom: 0px;
    margin-top: 0px;
  }
  span {
    font-size: 11px;
    color: #303030;
    text-align: -webkit-center;
  }
`;

const ActiveStatus = styled.div`
  i {
    font-size: 11px;
    margin-top: 28px;
    margin-left: -10px;
    border: 1px solid #ffffff;
    border-radius: 50px;
  }
  .green {
    color: ${colors.colorCoreGreen};
  }
  .red {
    color: ${colors.colorCoreRed};
  }
  .yellow {
    color: #dede0e;
  }
`;

const AddAgent = styled.div`
  width: 20px;
  height: 20px;
  background: #e9f1ff;
  border-radius: 50px;
  text-align: center;
  color: #03378c;
  font-size: 10px;

  p {
    padding-top: 2px;
    margin-bottom: 0px;
  }

  i {
    font-size: 11px;
    color: ${colors.colorPrimary};
    padding: 7px;
  }
`;

const BodyInner = styled.div`
  display: flex;
  width: 100%;
  .pink {
    color: #e51e5b;
    font-size: 14px;
    font-weight: 500;
  }
  .p1 {
    padding: 0.25rem;
  }
  .mr1 {
    margin-right: 0.5rem;
  }
  .badge {
    display: inline-block;
    padding: 0.5rem;
    font-size: 100%;
    font-weight: 400;
    line-height: 1rem;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25rem;
    background-color: #1752b7;
    min-width: auto;
  }
`;

const InnerBody = styled.div`
  width: 100%;
`;

const OuterCall = styled.div`
  background: ${colors.colorWhite};
  color: var(--black);
  padding: 1.5rem;
  display: flex;
  align-items: center;

  .dialInputButton {
    background: #03378c;
    color: ${colors.colorWhite};
    border-radius: 10px;
    font-size: 12px;
    font-weight: 400;
    border: none;
    outline: none;
    padding: 6px 15px;
    margin-left: 0.75rem;
  }

  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #1a1848;
    opacity: 1;
    /* Firefox */
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #1a1848;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #1a1848;
  }
`;

const DialInput = styled.div`
  width: 100%;

  input {
    border: 0;
    border-radius: 9px;
    outline: none;
    background: #e9f1ff;
    font-size: 12px;
    padding: 6px 10px;
    color: #1a1848;
    font-weight: 500;
    width: 100%;
  }
`;

const OuterFooter = styled.div`
    background: #f5f4f7;
    margin: 0;
    border-radius: 0px;
    padding: 12px 15px;
    display: flex;
    align-items: center;
    }

    .mauto{
        margin: auto;
    }

    button {
        outline: none;
        border: none;
        border-radius: 23px;
        background: #e51e5b;
        color: ${colors.colorWhite};
        font-size: 12px;
        padding: 5px 20px;
    }
`;

const MainBodyClass = styled.div`
  padding: 14px 15px;
  display: flex;
  align-items: center;
  background: #f9fafc;
  color: #1e67ee;

  h6 {
    font-size: 15px;
    font-weight: 400;
    margin-bottom: 0px;
    margin-top: 0px;
  }
`;

const InputBox = styled.div`
  position: relative i {
    position: absolute;
    right: 13px;
    top: 10px;
    color: #ced4da;
  }

  input {
    height: 35px;
    background-color: #f9fafc;
    width: 100%;
    border: 1px solid #e9f1ff;
    border-radius: 8px;
    font-size: 12px;
    padding: 7px;
    color: #8a8a8a;
    outline: none;
  }

  input:focus {
    background-color: #eeeeee69;
    box-shadow: none;
    border-color: #eee;
  }

  input::-webkit-input-placeholder {
    color: #8a8a8a;
    font-size: 12px;
  }
`;

export const CustomerAudio = styled.div`
audio::-webkit-media-controls-panel {
  background-color: #faedda;
  border-radius: 10px;
}
audio::-webkit-media-controls-mute-button {
  background-color: #f6e6c3;
  border-radius: 10px;
}
audio::-webkit-media-controls-play-button:hover {
  background-color: #f6e6c3;
  border-radius: 10px;
}
audio::-webkit-media-controls-current-time-display {
  color: #bfaa8f;
}
audio::-webkit-media-controls-time-remaining-display {
  color: #b0a097;
}
audio::-webkit-media-controls-timeline {
  background-color: #c7bca7;
  border-radius: 10px;
}
audio::-webkit-media-controls-volume-slider {
  background-color: #d1c9b5;
  border-radius: 25px;
}
.caption {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  margin-top: 10px;
  padding: 0px 8px 0px 15px;
}
`;

export const AgentAudio = styled.div`
audio::-webkit-media-controls-panel {
  background-color: #d6ecd5;
  border-radius: 10px;
}
audio::-webkit-media-controls-mute-button {
  background-color: #d3e8d0;
  border-radius: 10px;
}
audio::-webkit-media-controls-play-button:hover {
  background-color: #d3e8d0;
  border-radius: 10px;
}
audio::-webkit-media-controls-current-time-display {
  color: #82a583;
}
audio::-webkit-media-controls-time-remaining-display {
  color: #8a8a8a;
}
audio::-webkit-media-controls-timeline {
  background-color: #88a48a;
  border-radius: 10px;
}
audio::-webkit-media-controls-volume-slider {
  background-color: #9aa89a;
  border-radius: 25px;
}
.caption {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  margin-top: 5px;
  color: #fff;
  padding: 0px 8px 0px 15px;
}
`;

export {
  Row,
  DataWrapperClass,
  MainBox,
  Header,
  Footer,
  MainBody,
  OverflowClass,
  BodyClass,
  InnerBody,
  BodyInner,
  OuterFooter,
  AgentList,
  ActiveStatus,
  AddAgent,
  OuterCall,
  DialInput,
  MainBodyClass,
  InputBox
};



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/styles.js